import { Suspense, useEffect, useState } from "react"
import { Outlet } from "react-router-dom"
import { Header } from "./header"
import { LegacyHeader } from "./legacy/Topbar"
import { useRedux } from "../hooks"
import { apiError } from "../redux/error/actions"
import OutageBanner from "./header/OutageBanner"
import { Dialog, DialogContent } from "components/ui/dialog"
import { cn } from "lib/utils"
import { useFlags, useLDClient } from "launchdarkly-react-client-sdk"
import { Toaster } from "components/ui/toaster"

const loading = () => <></>

export const Layout = () => {
  const ldClient = useLDClient()
  const { useHeaderV2 } = useFlags()
  const { appSelector, dispatch } = useRedux()
  const [isLDReady, setIsLDReady] = useState(false)
  const [modal, setModal] = useState({
    show: false,
    error: "",
  })

  const { error } = appSelector((state) => ({
    error: state.Error.error,
  }))

  useEffect(() => {
    setModal({
      show: error !== "",
      error,
    })
  }, [error])

  // Wait for LaunchDarkly client to be ready
  // This helps avoid header flickering
  useEffect(() => {
    if (ldClient) {
      ldClient
        .waitUntilReady()
        .catch((err) => {
          console.error("LaunchDarkly initialization failed:", err)
        })
        .finally(() => {
          setIsLDReady(true)
        })
    }
  }, [ldClient])

  return (
    <div className="wrapper min-h-screen bg-slate-100">
      <div className={cn("content-page h-full", !useHeaderV2 && "pt-14")}>
        <div className="content">
          <Suspense fallback={loading()}>
            <OutageBanner />
            {!isLDReady ? (
              <div className="h-[var(--header-height)] w-full" />
            ) : useHeaderV2 ? (
              <Header />
            ) : (
              <LegacyHeader />
            )}
          </Suspense>
          <Outlet />
        </div>
      </div>
      <Toaster />

      <Dialog
        open={modal.show}
        onOpenChange={(value) => {
          if (!value) {
            dispatch(apiError(""))
          }
        }}
      >
        <DialogContent className="p-4 bg-red-500 text-white border-red-500">
          <div className="w-full p-1">
            <div className="text-center p-4">
              <h4 className="mb-6 font-semibold text-lg">Error!</h4>
              <p className="whitespace-pre-wrap leading-4">{modal.error}</p>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}
